// extracted by mini-css-extract-plugin
export var closeButton = "_56-0";